/**
 * Add the popup div that shows up next to the menu item when the menu is collapsed (less wide)
 * When the mouse enters a menu item move the popup to that spot and set the text to the menu
 * items text
 * @param shadowRoot
 */
export function appendPopup(shadowRoot: ShadowRoot) {
    const popup = document.createElement('div');
    popup.classList.add('ffmenu-popup');
    popup.setAttribute('data-testid', 'ffmenu-popup');
    shadowRoot.appendChild(popup);
    const scrollingParent = shadowRoot.getElementById(
        'ffmenu-scrolling-wrapper'
    );
    shadowRoot.querySelectorAll<HTMLElement>('.ffmenu-item').forEach(d => {
        let mouseTimer: NodeJS.Timeout;
        d.addEventListener('mouseenter', () => {
            //We are assuming that all .ffmenu-items are structured the same: <a><span>TEXT</span></a>
            const host = d.getElementsByTagName('span')[0];
            const popupName = host.getAttribute('data-popup-name');
            const isCollapsed = d.classList.contains('x-collapse');
            if (isCollapsed || popupName) {
                const top = d.offsetTop - scrollingParent.scrollTop;
                popup.style.top = `${top.toString()}px`;
                //innerHTML works at run time, but during unit tests only innerText is populated;
                popup.innerText = popupName || host.innerHTML || host.innerText;
                if (isCollapsed) {
                    popup.style.display = 'block';
                    popup.style.left = '74px'; //collapsed width + 10px;
                } else {
                    /*is Expanded*/
                    popup.style.left = '174px'; //expanded width + 10px;
                    mouseTimer = setTimeout(() => {
                        popup.style.display = 'block';
                    }, 1000);
                }
            }
        });
        d.addEventListener('mouseleave', () => {
            popup.style.display = 'none';
            clearTimeout(mouseTimer);
        });
    });
}
